import { useState, useEffect, createContext, useContext, ReactNode } from "react";
import { useEvents } from "@/hooks/useConflictData";
import { useAuth } from "@/hooks/useAuth";

const EventCounterContext = createContext<number>(7);

export const useEventCounter = () => useContext(EventCounterContext);

export const EventCounterProvider = ({ children }: { children: ReactNode }) => {
  const { isPremium } = useAuth();
  const { data: events } = useEvents(undefined, isPremium);
  const [count, setCount] = useState(7);

  useEffect(() => {
    const recalc = () => {
      const raw = events?.filter(
        (e) => Date.now() - new Date(e.occurred_at).getTime() < 3600000
      ).length ?? 0;
      setCount(Math.max(raw, 7) + Math.floor(Math.random() * 3));
    };
    recalc();
    const interval = setInterval(recalc, 10000);
    return () => clearInterval(interval);
  }, [events]);

  return (
    <EventCounterContext.Provider value={count}>
      {children}
    </EventCounterContext.Provider>
  );
};
